/** @module csi/widget/SelectListDnd */
define([
	"dojo/_base/declare",
	"csi/html",
	"./_DndHTML5ListMixin",
	"./SelectList"
], function(declare,html,_DndHTML5ListMixin,SelectList) {

	return declare([SelectList ,_DndHTML5ListMixin], {
		/**
		 * @override
		 * Drag and Drop initialization 
		 */
		startup: function(){
			this.inherited(arguments);
			this._dndInit();
		},
		
		/**
		 * @override
		 * Make option draggable
		 */
		_createOptionContainer: function(css, id, parentId){
			var div = this.inherited(arguments);
			this._setDraggable(div, id != this._getIdAll(), id, parentId);
			return div;
		},
		
		/**
		 * @override
		 * DnD Drop callback
		 */
		_onDragDrop: function(dragElementId, targetGroup, nextElementId, nodesBeingDragged) {
			// Update store with new position of dropped element
			const store = this.store;
			const itemSource = store.get(dragElementId);
			itemSource.parent = (targetGroup === html.DRAG_ROOT_ID) ? null : targetGroup;
			const itemDest = nextElementId ? store.get(nextElementId) : null; // append to the end, if no destination
			store.put(itemSource, {before:itemDest});
			
			// Update store and list with new position of children
			if (this._bDragGroup){
				const nodes = this.nodesBeingDragged.children;
				const len = nodes.length;
				for (let i=0; i < len; i++) {
					const node = nodes[i];
					const nodeId = html.getDataAttribute(node, html.DRAG_ITEM_ID);
					const nodeItem = store.get(nodeId);
					store.put(nodeItem, {before:itemDest});
				};
			}
		}
	});
});
